import { Controller } from "@hotwired/stimulus"

// prefetch
// ---------------------------------------------------------------
// Warms Turbo's snapshot cache for a list of URLs on connect.
// Each URL is also fetched into WKWebView's NSURLCache (process-wide),
// so newly-spawned native WebViews (e.g. modal screens) can serve
// from cache when Cache-Control allows.
//
// Usage:
//   <div data-controller="prefetch"
//        data-prefetch-urls-value='["<%= settings_path %>"]'></div>
//
// Dedup: per-WebView via Turbo's SnapshotCache. Across WebViews,
// dedup happens at NSURLCache once Cache-Control is set server-side.

export default class extends Controller {
  static values = {
    urls: { type: Array, default: [] }
  }

  connect() {
    const urls = this.urlsValue.filter(Boolean)
    if (urls.length === 0) return
    urls.forEach((url) => {
      if (this._alreadyWarmed(url)) return
      this._markWarmed(url)
      this._preloadOne(url)
    })
  }

  _storageKey(url) {
    return `prefetch:warmed:${url}`
  }

  _alreadyWarmed(url) {
    try { return sessionStorage.getItem(this._storageKey(url)) === "1" } catch (_) { return false }
  }

  _markWarmed(url) {
    try { sessionStorage.setItem(this._storageKey(url), "1") } catch (_) {}
  }

  _preloadOne(url) {
    const preloader = window.Turbo?.session?.preloader
    if (preloader && typeof preloader.preloadURL === "function") {
      const link = document.createElement("a")
      link.href = url
      link.setAttribute("data-turbo-preload", "")
      preloader.preloadURL(link).catch(() => {})
      return
    }

    fetch(url, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        "Accept":      "text/html",
        "Sec-Purpose": "prefetch",
        "Purpose":     "prefetch",
        "X-Prefetch":  "boot"
      }
    }).catch(() => {})
  }
}
